import React from "react";

const STATUS_CLASS = {
  Pending: "csv-log-status-badge csv-log-status-badge--pending",
  Completed: "csv-log-status-badge csv-log-status-badge--completed",
  Failed: "csv-log-status-badge csv-log-status-badge--failed",
};

const STATUS_TEXT = {
  Pending: "Pending",
  Completed: "Complete",
  Failed: "Failed",
};

const CsvLogStatusBadge = ({ statusLabel }) => {
  const label = statusLabel || "—";
  if (label === "—") return "—";

  return (
    <span className={STATUS_CLASS[label] || "csv-log-status-badge"}>
      {STATUS_TEXT[label] || label}
    </span>
  );
};

export default CsvLogStatusBadge;
